// extracted by mini-css-extract-plugin
export default {"header":"UUJbuixF","enter":"_7YdO51E7","lock":"PjEWoqz4","heading":"WMbu9kXK","subtitle":"FsCQELlx"};